import React, { useEffect, useRef } from 'react';

interface AdSlotProps {
  isPaid: boolean;
  onUpgradeClick: () => void;
}

const AdSlot: React.FC<AdSlotProps> = ({ isPaid, onUpgradeClick }) => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Push ad request to AdSense once the component mounts for free users
    if (!isPaid && typeof window !== 'undefined') {
      try {
        ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
      } catch {
        // AdSense may not be loaded yet or ad blocker active; fail silently
      }
    }
  }, [isPaid]);

  if (isPaid) return null;

  return (
    <div className="mt-8 border-t border-slate-700 pt-6">
      {/* Subtle upgrade CTA */}
      <div className="text-center mb-6">
        <p className="text-slate-400 text-sm mb-2">
          欲求更深入的智慧？獲取大師親自為您批算的命盤解讀
        </p>
        <button
          onClick={onUpgradeClick}
          className="text-amber-400 hover:text-amber-300 text-sm underline transition"
        >
          解鎖專屬解讀 →
        </button>
      </div>

      {/* AdSense slot */}
      <div className="flex justify-center" ref={adRef}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
          data-ad-slot="XXXXXXXXXX"
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </div>
  );
};

export default AdSlot;
